export const templates = new Set(['gql', 'graphql']);
